import { AudioProcessOutput, UserSettings } from "../../wasm/pkg/wasm";
import { StreamFormat } from "./wasm.model";

export interface AudioWebWorkerInitSettings {
  onInit: () => void;
  onError: (e: string) => void;
  onLatestMusicalData: (args: AudioProcessOutput) => void;
}

export interface PartialAudioBlobToWasm {
  isFirstBlob: boolean;
  streamFormat: StreamFormat;
  blob: Blob;
}

export interface CompleteAudioBlobToWasm {
  blob: Blob;
}

export interface AudioWebWorkerInputControls {
  /**
   * This should result in a (debounced) callback to the given onLatestMusicalData.
   * So the webworker shouldn't need to know about play/pause/stop.
   */
  sendNextPartialAudioBlob: (args: PartialAudioBlobToWasm) => void;
  /**
   * The usecase of drag+drop local file should allow for more or less instant total analysis.
   */
  sendCompleteAudioBlob: (args: CompleteAudioBlobToWasm) => void;
  /**
   * Tell the web worker to prepare for a new file or recording.
   */
  resetAudioState: () => void;
  /**
   * Input user preferences, to apply when processing audio.
   */
  updateSettings: (settings: UserSettings) => void;
  /**
   * Tell WASM to expect a jump to a different slice of time.
   */
  audioTimeSeekJump: (integerNewTime: number) => void;
}

export const MSG_FROM_WASM = {
  worker_ready: "worker_ready",
  worker_error: "worker_error",
  worker_music_data: "worker_music_data",
};

export const MSG_TO_WASM = {
  partial_audio: "partial_audio",
  complete_audio: "complete_audio",
  /** submit an AudioCommand e.g. Exit, UpdateSettings, Pause */
  cmd: "cmd",
};
